function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_249",
  "data-name": "Group 249",
  transform: "translate(312.188 -2016.315) rotate(45)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_24",
  "data-name": "Line 24",
  y2: 14,
  transform: "translate(1212.5 1639.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_25",
  "data-name": "Line 25",
  x1: 14.5,
  transform: "translate(1205.5 1646.5)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}));

var SvgMenuClose = function SvgMenuClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.96,
    height: 10.96,
    viewBox: "0 0 10.96 10.96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MenuClose.b7fcce3d.svg";
export { ForwardRef as ReactComponent };